export { default as QuickBookingRestB } from './QuickBookingRestB'
export { default as QuickBookingRestBSkeleton } from './Skeleton'
